import { useContext } from 'react'
import { DBContext } from './DBContext.ts'
import type { DBContextValue } from './DBContext.ts'
import type { StateDBService } from '../lib/db/state-db-service.ts'

export function useDB(): DBContextValue {
  const ctx = useContext(DBContext)
  if (!ctx) throw new Error('useDB must be used inside <DBProvider>')
  return ctx
}

export function useStateService(): StateDBService {
  const { service, isReady } = useDB()
  if (!isReady || !service) throw new Error('StateDBService not ready')
  return service
}
